import * as React from 'react';
import ChatWelcomeMessage from 'chat/components/ChatWelcomeMessage';
import { MessageNullState } from 'constants/CopyConstants';
import StreamScrollableArea from './StreamScrollableArea';
import TextWithEntities from 'components/TextWithEntities';
import TextEntities from 'lib/TextEntities';

export class StreamPlaceholder extends React.Component<any, any> {
  render() {
    return (
      <StreamScrollableArea>
        <ChatWelcomeMessage
          firstHeader={<div>Hi! This is the beginning of your conversation.</div>}
          secondHeader={
            <TextWithEntities
              text={MessageNullState.secondHeader}
              entities={TextEntities.parseEmoji(MessageNullState.secondHeader)}
            />
          }
        />
      </StreamScrollableArea>
    );
  }
}

export default StreamPlaceholder;
